import { createFileRoute } from '@tanstack/react-router';

import { HelpFaqPage } from '@/pages/help';

export const Route = createFileRoute('/protected/_layout/help/faq')({
  component: HelpFaqRoute,
});

function HelpFaqRoute() {
  return <HelpFaqPage />;
}
